/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CouponListItemViewModelPaginatedResponse } from "../types/CouponListItemViewModelPaginatedResponse.ts";
import { couponListItemViewModelSchema } from "./couponListItemViewModelSchema.ts";

export const couponListItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => couponListItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<CouponListItemViewModelPaginatedResponse>;
